import { Box, Grid, Typography } from "@mui/material";
import styled from "styled-components";
const StyledBox = styled(Box)`
  width: 100%;
  height: 750px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-image: url("/images/workWhitUs/about-us.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-blend-mode: overlay;

  @media (min-width: 0px) {
    height: 850px;
    background-position: right 85% bottom 45%;
  }

  @media (min-width: 600px) {
    height: 850px;
    background-position: right 85% bottom 45%;
  }

  @media (min-width: 960px) {
    height: 700px;
  }

  @media (min-width: 1280px) {
    height: 850px;
  }

  @media (min-width: 1920px) {
    height: 1000px;
  }
`;

export default function AboutUs() {
  return (
    <Box width="100%" height="100%">
      <StyledBox>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          color="white"
          pt={{ xs: 8, sm: 3, md: 3 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={4} xl={5} textAlign="center">
            <img
              src="/images/default.png"
              alt="Logo ITOP"
              style={{ maxWidth: "250px" }}
            />
          </Grid>
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={1}
            xl={2}
            pt={{ xs: 3, sm: 3, md: 3 }}
          />
          <Grid item xs={10.5} sm={10} md={8} lg={5} xl={3.5}>
            <Typography
              variant="body1"
              textAlign={{
                xs: "center",
                sm: "center",
                md: "center",
                lg: "left",
                xl: "left",
              }}
              fontSize="1rem"
              lineHeight={1.7}
              sx={{ fontFamily: '"Mulish", sans-serif' }}
            >
              Fundada em 2016 na cidade de Alfenas por Marcos Pires, a ITOP
              Telecom iniciou sua jornada com um objetivo claro: oferecer
              serviços de qualidade que transformassem a experiência de conexão
              de seus clientes. Com o passar dos anos e a parceria do sócio
              Bruno Gomes, a empresa cresceu de forma expressiva, expandindo
              suas operações para diversas cidades e estados.
            </Typography>

            <Box mt={3}>
              <Typography
                variant="body1"
                textAlign={{
                  xs: "center",
                  sm: "center",
                  md: "center",
                  lg: "left",
                  xl: "left",
                }}
                fontSize="1rem"
                lineHeight={1.7}
                sx={{ fontFamily: '"Mulish", sans-serif' }}
              >
                Hoje, a ITOP Telecom é referência em telecomunicações,
                reconhecida por sua excelência e compromisso. Atuamos em
                Alfenas, Machado, Paraguaçu, Areado, Belo Horizonte, Inhaúma,
                Sete Lagoas e Ribeirão Preto, sempre garantindo serviços de alta
                performance e um atendimento diferenciado.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </StyledBox>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        bgcolor="#f0f0f0"
        pt={{ xs: 8, sm: 5, md: 5 }}
        pb={{ xs: 8, sm: 5, md: 5 }}
      >
        <Grid item xs={10.5} sm={10} md={8} lg={5} xl={3.5} textAlign="center">
          <Box mt={3} width="100%">
            <Typography
              variant="body1"
              textAlign={{
                xs: "left",
                sm: "left",
                md: "left",
                lg: "left",
                xl: "left",
              }}
              fontSize="1rem"
              lineHeight={1.7}
              sx={{ fontFamily: '"Mulish", sans-serif' }}
            >
              Operamos no modelo quadriplay, oferecendo um portfólio completo de
              soluções que incluem:
            </Typography>

            <Box
              component="ul"
              sx={{
                mt: 2,
                pl: { xs: 3, lg: 4 },
                px: { xs: 6, lg: "auto" },
                textAlign: "left",
                fontSize: "1rem",
                lineHeight: 1.7,
                fontFamily: '"Mulish", sans-serif',
                listStyleType: "disc",
                "& li::marker": {
                  color: "#FF7C06",
                },
              }}
            >
              <li>Telefonia Móvel e Fixa;</li>
              <li>
                Internet Residencial e Empresarial de Alta Velocidade,
                garantindo conexão estável e confiável para todas as suas
                necessidades;
              </li>
              <li>TV com canais diversificados e conteúdos exclusivos.</li>
            </Box>

            <Typography
              variant="body1"
              textAlign="left"
              fontSize="1rem"
              lineHeight={1.7}
              sx={{ fontFamily: '"Mulish", sans-serif', mt: 2 }}
            >
              Nossa missão é superar as expectativas de nossos clientes,
              entregando inovação, confiabilidade e um serviço excepcional,
              alinhados aos valores que nos impulsionaram desde o início.
            </Typography>
          </Box>
        </Grid>
        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={1.5}
          xl={3}
          pt={{ xs: 3, sm: 3, md: 3 }}
        />
        <Grid item xs={12} sm={12} md={12} lg={4} xl={2.5} textAlign="center">
          <img
            src="/images/about-us-vagalume.png"
            alt="Logo ITOP"
            style={{ maxWidth: "350px" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
